import React, { ComponentType, memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './BaseSelect.module.less'

export interface IInputPlaceholderProps {
  children: ReactNode
  Icon?: ComponentType<ISvgIconProps>
  className?: string
  iconClassName?: string
}

export const InputPlaceholder = memo<IInputPlaceholderProps>(function InputPlaceholder({
  className,
  iconClassName,
  Icon,
  children
}) {
  return (
    <>
      {Icon && <Icon className={cn(s.icon, s.icon_beforeInput, iconClassName)} size="nm" />}
      <div className={cn(s.selectText, { [s.selectText_icon]: Boolean(Icon) }, s.selectText_placeholder, className)}>
        {children}
      </div>
    </>
  )
})
